// app/user-preset.ts — схема пользовательского пресета таблицы (хранится в localStorage,
// экспортируется и импортируется как JSON).

import { z } from "zod";
import {
  filterClauseSchema,
  sortClauseSchema,
  TEXT_OPERATORS,
  type UserPreset,
} from "../domain";

const labelMapSchema = z.record(z.string(), z.string());
const columnFormatSchema = z.object({
  label: labelMapSchema,
  tooltip: labelMapSchema.optional(),
  headerColor: z.string().optional(),
  headerTextColor: z.string().optional(),
  cellColor: z.string().optional(),
  cellTextColor: z.string().optional(),
});

export const userPresetSchema = z.object({
  id: z.string(),
  name: z.string(),
  columns: z.array(z.string()),
  filters: z.array(filterClauseSchema),
  sort: z.array(sortClauseSchema),
  pageSize: z.number(),
  stickyColumns: z.array(z.string()).optional(),
  hiddenColumns: z.array(z.string()).optional(),
  columnGroups: z
    .array(
      z.object({
        id: z.string(),
        label: z.string(),
        columnIds: z.array(z.string()),
        collapsedByDefault: z.boolean().optional(),
      }),
    )
    .optional(),
  columnMeta: z.record(z.string(), columnFormatSchema).optional(),
  availableFilters: z
    .array(
      z.object({
        propertyKey: z.string(),
        order: z.number().optional(),
        uiType: z.string(),
        format: z.object({
          label: labelMapSchema,
          tooltip: labelMapSchema.optional(),
        }),
        conditions: z.array(filterClauseSchema),
      }),
    )
    .optional(),
  lists: z
    .array(
      z.object({
        propertyKey: z.string(),
        items: z.array(z.object({ value: z.string(), label: labelMapSchema })),
      }),
    )
    .optional(),
  defaultFilter: z
    .object({
      column: z.string(),
      operator: z.enum(TEXT_OPERATORS).optional(),
    })
    .optional(),
  version: z.number(),
  isSeed: z.boolean().optional(),
  createdAt: z.string(),
});

/**
 * Разбор значения из localStorage: неверный формат или недоступное хранилище → пустой список.
 */
export function parseUserPresets(raw: string | null): UserPreset[] {
  if (!raw) return [];
  try {
    const parsed = userPresetSchema.array().safeParse(JSON.parse(raw));
    return parsed.success ? (parsed.data as UserPreset[]) : [];
  } catch {
    return [];
  }
}
